import React, { useState, useEffect, useContext } from "react";
import { Trans, useTranslation } from "react-i18next";
import "../../styles/pages/enquiry/WorkshopDetailPage.scss";
import Popup from "../../components/Popup";
import { enquiryContext } from "./Enquiry";
import { fetchWorkshopList, cancelWorkshop } from "../../api/apiManagement";
import { GlobalContext } from "../../App";
function WorkshopDetailPage() {
  const {
    enquiryCourseData,
    setCurrentStep,
    currentLang,
    handleEnquiry,
    enquiryLoginData,
    setWorkshopChangeData,
    workshopRecordId,
    setWorkshopRecordId,
  } = useContext(enquiryContext);
  const { isLogin, setIsLoading } = useContext(GlobalContext);
  const { t, i18n } = useTranslation();
  const [openPopup, setOpenPopup] = useState(false);
  const [currentId, setCurrentId] = useState();
  const [canceled, setCanceled] = useState(false);
  const [canNotChange, setCanNotChange] = useState(false);

  useEffect(() => {
    if (i18n.language !== currentLang) {
      setCurrentStep(0);
      handleEnquiry();
    }
  }, [i18n.language]);

  function handleCancelWorkshop(workshop_id) {
    setIsLoading(true);
    let data = {
      email: enquiryLoginData?.email,
      phone: 852 + enquiryLoginData?.phone,
      id: workshop_id,
    };

    if (isLogin) {
      data.email = JSON.parse(localStorage.getItem("user_data"))?.email;
      data.phone = JSON.parse(localStorage.getItem("user_data"))?.phone;
      data.sua_id = JSON.parse(localStorage.getItem("user_data"))?.sua_id;
      data.token = JSON.parse(localStorage.getItem("jwt"))?.signature;
    }

    cancelWorkshop(data)
      .then((res) => {
        setOpenPopup(false);
        setIsLoading(false);
        setCurrentStep(0);
        handleEnquiry();
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function handleFetchWorksohpList(workshop_detail_id) {
    setIsLoading(true);
    const data = {
      lang: i18n.language,
      workshop_detail_id: workshop_detail_id,
    };

    fetchWorkshopList(data)
      .then((res) => {

        setIsLoading(false);
        setWorkshopChangeData(res.data.Data);
        setCurrentStep(2);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }
  return (
    <div className="workshop-detail-container">
      {openPopup && !canceled && !canNotChange ? (
        <Popup
          title={t("enquiry:popupTitle")}
          buttonLeftText={t("global:popupLeftText")}
          buttonRightText={t("global:popupRightText")}
          setOpenPopup={setOpenPopup}
          handleClick={() => handleCancelWorkshop(currentId)}
        />
      ) : (
        <></>
      )}

      {openPopup && canceled && !canNotChange ? (
        <Popup
          title={t("enquiry:popupCancel")}
          buttonLeftText={t("global:popupLeftText")}
          buttonRightText={t("global:popupRightText")}
          setOpenPopup={setOpenPopup}
          handleClick={() => setOpenPopup(false)}
          haveButton={false}
        />
      ) : (
        <></>
      )}

      {openPopup && canNotChange ? (
        <Popup
          title={t("enquiry:popupNotChange")}
          buttonLeftText={t("global:popupLeftText")}
          buttonRightText={t("global:popupRightText")}
          setOpenPopup={setOpenPopup}
          handleClick={() => setOpenPopup(false)}
          haveButton={false}
        />
      ) : (
        <></>
      )}
      <div className="maximum-three-times">
        <Trans i18nKey="enquiry:maximumThreeTimes" />
      </div>
      <div className="scroll-x">
        <table className="workshop-table-container">
          <thead>
            <tr className="workshop-rows">
              <th>
                <Trans i18nKey="enquiry:workshopName" />
              </th>
              <th>
                <Trans i18nKey="enquiry:location" />
              </th>
              <th>
                <Trans i18nKey="enquiry:date" />
              </th>
              <th>
                <Trans i18nKey="enquiry:time" />
              </th>
              <th>
                <Trans i18nKey="enquiry:status" />
              </th>
              <th>
                <Trans i18nKey="enquiry:numberOfChange" />
              </th>
              <th>
                <Trans i18nKey="enquiry:updateNCancel" />
              </th>
            </tr>
          </thead>
          <tbody>
            {enquiryCourseData.map((detail, key) => (
              <tr key={key}>
                <td>{detail.title}</td>
                <td>{detail.location}</td>
                <td>{detail.workshop_date.slice(0, 10)}</td>
                <td>{detail.timeslot}</td>
                <td>
                  {detail.attend_status === -1 ? (
                    <Trans i18nKey="enquiry:cancel" />
                  ) : detail.attend_status === 0 ? (
                    <Trans i18nKey="enquiry:notAttended" />
                  ) : detail.attend_status === 1 ? (
                    <Trans i18nKey="enquiry:attend" />
                  ) : detail.attend_status === 2 ? (
                    <Trans i18nKey="enquiry:walkIn" />
                  ) : detail.attend_status === 10 ? (
                    <Trans i18nKey="enquiry:waitingList" />
                  ) : (
                    <></>
                  )}
                </td>
                <td>{detail.change_count}</td>
                <td className="workshop-button-container">
                  {detail.is_editable === 1 ? (
                    <button
                      className="workshop-button"
                      onClick={() => {
                        handleFetchWorksohpList(detail.workshop_detail_id);
                        setWorkshopRecordId(detail.id);
                      }}
                    >
                      <Trans i18nKey="enquiry:update" />
                    </button>
                  ) : (
                    <button
                      className="cant-workshop-button"
                      onClick={() => {
                        setCanNotChange(true);
                        setCanceled(false);
                        setOpenPopup(true);
                      }}
                    >
                      <Trans i18nKey="enquiry:update" />
                    </button>
                  )}
                  {detail.is_cancell === 1 ? (
                    <button
                      className="workshop-button"
                      onClick={() => {
                        setCanNotChange(false);
                        setCanceled(false);
                        setOpenPopup(true);
                        setCurrentId(detail.id);
                      }}
                    >
                      <Trans i18nKey="enquiry:cancel" />
                    </button>
                  ) : (
                    <button
                      className="cant-workshop-button"
                      onClick={() => {
                        setCanNotChange(false);
                        setCanceled(true);
                        setOpenPopup(true);
                      }}
                    >
                      <Trans i18nKey="enquiry:cancel" />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
//attend_status -1 canceled, 0 basic, 1 check-in ed, 2 walk-in, 10 waiting list
export default WorkshopDetailPage;
